import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { GlobalVariable } from 'src/app/global';
import { BaseComponent } from 'src/app/models/base-component';

declare const resaltarPestañaMenu:any;

@Component({
    selector: 'app-pagina-no-encontrada',
    templateUrl: './pagina-no-encontrada.component.html',
    styleUrls: ['./pagina-no-encontrada.component.css'],
    standalone: false
})
export class PaginaNoEncontradaComponent extends BaseComponent implements OnInit {

  server_url=GlobalVariable.SERVER_URL;
  constructor(private router: Router,
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public modalService: NgbModal,
    public usuarioService:UsuarioService) { 
      super(persistenciaService,modalService,generalService,usuarioService);
  }

  ngOnInit(): void {
    this.init();
		this.buscarSubAplicacion(this.router.url.substring(1));
    if(this.router.url.includes("comprobantes") || this.router.url.includes("contabilidad-cuenta")){
      window.location.href=this.server_url+"v1/#"+this.router.url;
    }
  }

  ngAfterViewInit() {
		resaltarPestañaMenu(this.router.url.substring(1)+"1");
	}

}
